<aside class="sidebar" [class.mobile-menu-open]="menuMobileOuvert()">
  <button
    class="mobile-menu-toggle"
    type="button"
    [attr.aria-expanded]="menuMobileOuvert()"
    aria-label="Ouvrir le menu principal"
    (click)="toggleMenuMobile()"
  >
    <span class="material-symbols-outlined">{{ menuMobileOuvert() ? 'close' : 'menu' }}</span>
  </button>

  <div class="brand">
    <img ngSrc="img/tecsol_blanc.png" width="1202" height="248" alt="Tecsol" />
  </div>

  @if (accesMetier()) {
    <a
      class="mobile-intervention-button"
      routerLink="/maintenance"
      [attr.aria-label]="tooltipInterventions()"
      [title]="tooltipInterventions()"
    >
      <span class="material-symbols-outlined">construction</span>
    </a>
  }

  <button class="mobile-notification-button" type="button" aria-label="Notifications">
    <span class="material-symbols-outlined">notifications</span>
  </button>

  <button
    class="mobile-logout-button"
    type="button"
    aria-label="Se déconnecter"
    (click)="seDeconnecter()"
  >
    <span class="material-symbols-outlined">logout</span>
  </button>

  <div class="mobile-menu-panel">
    <nav class="sidebar-nav" aria-label="Navigation principale">
      @if (accesMetier()) {
        <a class="nav-item" [routerLink]="lienDashboard()" [class.active]="isDashboardActif()">
          <span class="material-symbols-outlined">solar_power</span>
          <span>Dashboard</span>
        </a>
        <a class="nav-item" [routerLink]="lienTickets()" [class.active]="isActive('/tickets')">
          <span class="material-symbols-outlined">problem</span>
          <span>Tickets</span>
        </a>
        <a class="nav-item" routerLink="/maintenance" [class.active]="isActive('/maintenance')">
          <span class="material-symbols-outlined">event</span>
          <span>Maintenance</span>
        </a>
        <a class="nav-item" routerLink="/indicateurs" [class.active]="isActive('/indicateurs')">
          <span class="material-symbols-outlined">stacks</span>
          <span>Indicateurs</span>
        </a>
        <a
          class="nav-item"
          routerLink="/rentabilite-performance"
          [class.active]="isActive('/rentabilite-performance')"
        >
          <span class="material-symbols-outlined">monitoring</span>
          <span>Performance</span>
        </a>
        <a class="nav-item" routerLink="/rapports" [class.active]="isActive('/rapports')">
          <span class="material-symbols-outlined">description</span>
          <span>Rapports</span>
        </a>
        <a
          class="nav-item"
          [routerLink]="lienGraphiques()"
          [class.active]="isActive('/graphiques')"
        >
          <span class="material-symbols-outlined">bar_chart</span>
          <span>Graphiques</span>
        </a>
      }
      @if (administration()) {
        <details class="administration-menu" [open]="isActive('/materiel')">
          <summary class="nav-item" [class.active]="isActive('/materiel')">
            <span class="material-symbols-outlined" aria-hidden="true">admin_panel_settings</span>
            <span>Administration</span>
            <span class="material-symbols-outlined submenu-chevron" aria-hidden="true"
              >expand_more</span
            >
          </summary>
          <a
            class="nav-item submenu-item"
            [routerLink]="lienMateriel()"
            [class.active]="isActive('/materiel')"
            [attr.aria-current]="isActive('/materiel') ? 'page' : null"
          >
            <span class="material-symbols-outlined" aria-hidden="true">developer_board</span>
            <span>Matériel</span>
          </a>
        </details>
        <a class="nav-item" routerLink="/configuration" [class.active]="isActive('/configuration')">
          <span class="material-symbols-outlined">settings</span>
          <span>Configuration</span>
        </a>
      }
      <a class="nav-item" routerLink="/assistant" [class.active]="isActive('/assistant')">
        <span class="material-symbols-outlined">electric_bolt</span>
        <span>Assistant</span>
      </a>
      @if (administration()) {
        <a class="nav-item" routerLink="/tests" [class.active]="isActive('/tests')">
          <span class="material-symbols-outlined">science</span>
          <span>Tests</span>
        </a>
      }
    </nav>

    <a class="help-link nav-item" routerLink="/aide" [class.active]="isActive('/aide')">
      <span class="material-symbols-outlined">help</span>
      <span>Aide</span>
    </a>
  </div>
</aside>
